// ** Navigation imports
// import dashboards from './dashboards'
import roleKordinators from './role-kordinators'
import roleEntrys from './role-entrys'
import roleKindergaten from './role-kindergaten'
import roleLaporan from './role-laporan'

// ...dashboards, 
// ** Merge & Export
export default [...roleKordinators, ...roleKindergaten, ...roleEntrys, ...roleLaporan]
